export default "__VITE_ASSET__bmDvm8qS__"